import React, { useState } from 'react'
import AOS from "aos"; // Import AOS library
import DeveloperSec from '../sections/developer/DeveloperSec'
import Breadcrumb from '../components/Breadcrumb'
import Banner from '../components/Banner';
import * as constants from "../constants";
import { fetchAPI } from '../helper/fetchAPI';
import CustomHelmet from '../components/CustomHelmet';
import { t } from 'i18next';
import FullScreenLoader from '../components/FullScreenLoader';
import NotFoundSec from '../sections/pageNotFound/NotFoundSec';
import { useTranslation } from 'react-i18next';
import { useCountryPrefix } from '../routes/useCountryPrefix';

const Developer = () => {
    const countryPrefix = useCountryPrefix();

    const [developer, setDeveloper] = useState({
        items: [],
        totalPages: 1,
        pageIndex: 1,
    });
    let apiUrl = process.env.REACT_APP_API_URL;

    const { i18n } = useTranslation();
    const isArabic = i18n.language === "ar";
    const language = isArabic ? "ar" : "en";
    const [isLoaded, setIsLoaded] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const [pageIndex, setPageIndex] = useState(1);
    const [loadError, setLoadError] = useState(false); // NEW



    const fetchData = async (pageIndex) => {

        apiUrl = `${apiUrl}${constants.developer}?language=${language}&region_id=${countryPrefix}&PageIndex=${pageIndex}&PageSize=5`;
        const res = await fetchAPI(apiUrl, "Get");
        if (res?.status === 200) {
            setDeveloper((prevData) => ({
                ...res.data,
                items: [...(prevData?.items || []), ...res.data.items]
            }))
            setIsLoaded(true)
            setLoadingMore(false)

        } else {
            setLoadError(true); // set error flag
            setIsLoaded(true);
        }
    }

    React.useEffect(() => {
        AOS.init();
        fetchData(pageIndex);
    }, [pageIndex]);

    const pathLang = isArabic ? "/ar" : "";
    const pathName = [
        { name: t("home"), path: `/${countryPrefix}${pathLang ? `${pathLang}` : ""}` },
        { name: t("developers") }
    ];

    const handleLoadMore = () => {
        setLoadingMore(true)
        setPageIndex(prev => prev + 1);
    };


    // if (!isLoaded) {
    //     return (
    //         <FullScreenLoader />
    //     )
    // }
    if (loadError) {
        return (
            <NotFoundSec title={t("opps")} desc={t("dev_not_found")} img={"/assets/img/not-found.svg"} cssstyle={"p-0"} />)
    }
    return (
        <>
            {!isLoaded && <FullScreenLoader style={{ minHeight: '100vh' }} />}
            <CustomHelmet
                title={"Exclusive Real Estate Across Egypt"}
                desc={'Connect Homes makes exploring real estate in Egypt simple and seamless.'}
            />
            <Banner
                title={t("developers")}
                desc={t("banner_desc")}></Banner >
            <Breadcrumb pathName={pathName}></Breadcrumb>
            <div className="aspect-[16/9] w-full">

                <DeveloperSec data={developer} onLoadMore={handleLoadMore} loadingMore={loadingMore}></DeveloperSec>
            </div>
        </>
    )
}

export default Developer